





























import { defineComponent } from "@vue/composition-api";
import { Location } from "vue-router";
import { Subscription } from "@teacherskaya/api-provider/dist/api/SubscriptionProvider";
import ProfileRecurringItem from "@/views/PageProfile/components/ProfileRecurringView/components/ProfileRecurringItem.vue";
import ConfirmRecurringAction from "@/components/ConfirmRecurringAction";
import BlockAddSubscription from "@/components/BlockAddSubscription";
import FormatMoney from "@/components/FormatMoney/FormatMoney";
import BlockBase from "@/components/BlockBase.vue";
import GoForward from "@/components/GoForward.vue";

export default defineComponent({
  name: "RecurringView",
  components: { ConfirmRecurringAction, ProfileRecurringItem, BlockBase, GoForward, FormatMoney, BlockAddSubscription },
  props: {
    texts: { type: Object as () => Record<string, string>, required: true },
    subscriptions: { type: Array as () => Subscription[], required: true },
    allSubsLocation: { type: Object as () => Location, required: true },
    isSubscribers: { type: Boolean, default: false },
    userId: { type: String, default: "" },
  },
});
